import React from 'react';
import {
  ContactSection,
  Container,
  SectionHeader,
  SectionTitle,
  SectionSubtitle,
  ContactContent,
  ContactInfo,
  ContactItem,
  ContactIcon,
  FacebookIcon,
  ContactDetails
} from './Contact.styles.jsx';

const Contact = () => {

  return (
    <ContactSection id="contact">
      <Container>
        <SectionHeader>
          <SectionTitle>Contactați-ne</SectionTitle>
          <SectionSubtitle>
            Ai nevoie de servicii de instalații? Contactați-ne pentru o ofertă gratuită!
          </SectionSubtitle>
        </SectionHeader>

        <ContactContent>
          <ContactInfo>
            <ContactItem>
              <ContactIcon>📞</ContactIcon>
              <ContactDetails>
                <h3>Telefon</h3>
                <p><a href="tel:+40721150463">+40721150463</a></p>
                <span>Disponibil 24/7</span>
              </ContactDetails>
            </ContactItem>

            <ContactItem>
              <ContactIcon>📧</ContactIcon>
              <ContactDetails>
                <h3>Email</h3>
                <p><a href="mailto:instalatii.pro@yahoo.com">instalatii.pro@yahoo.com</a></p>
                <span>Răspundem rapid</span>
              </ContactDetails>
            </ContactItem>

            <ContactItem>
              <ContactIcon>📍</ContactIcon>
              <ContactDetails>
                <h3>Zona de Acțiune</h3>
                <p>Ploiești, București și împrejurimi</p>
                <span>Servicii în toată țara</span>
              </ContactDetails>
            </ContactItem>

            <ContactItem>
              <ContactIcon>⏰</ContactIcon>
              <ContactDetails>
                <h3>Program</h3>
                <p>Luni - Vineri: 8:00 - 18:00</p>
                <span>Urgențe 24/7</span>
              </ContactDetails>
            </ContactItem>

            <ContactItem>
              <ContactIcon>
                <FacebookIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </FacebookIcon>
              </ContactIcon>
              <ContactDetails>
                <h3>Facebook</h3>
                <p><a href="https://www.facebook.com/profile.php?id=61583427381552" target="_blank" rel="noopener noreferrer">Vizitează-ne pe Facebook</a></p>
                <span>Urmărește-ne pentru oferte</span>
              </ContactDetails>
            </ContactItem>
          </ContactInfo>
        </ContactContent>
      </Container>
    </ContactSection>
  );
};

export default Contact;

